export default __webpack_public_path__ + "static/media/homeCrypto.b5c41ffc.PNG";